export default __webpack_public_path__ + "static/media/icon-check.16a40c18.svg";